import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import { StatusCessaoEnum } from 'components/Shared/Enums/StatusCessaoEnum';

const ModalCancelarOperacao = ({ open, onClose, loadingBtnAlterarStatus, alterarStatusCessao }) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    if (reason === 'escapeKeyDown') return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      className="dialog-conta modal-confirmacao-upload"
    >
      <DialogTitle className="titulo-modal">Cancelar operação</DialogTitle>

      <DialogContent className="dialog-conta__content">
        <Typography variant="body2" className="dialog-conta__subtitle">
          Deseja realmente cancelar esta operação? Esta ação não poderá ser desfeita.
        </Typography>
      </DialogContent>

      <DialogActions className="dialog-conta__actions modal-confirmacao-conta">
        <Button
          onClick={onClose}
          className="dialog-conta__btn-cancelar"
          disabled={loadingBtnAlterarStatus}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => alterarStatusCessao(StatusCessaoEnum.INDEFERIDO)}
          disabled={loadingBtnAlterarStatus}
          className="dialog-conta__btn-escolher"
        >
          {!loadingBtnAlterarStatus && <>Confirmar</>}
          {loadingBtnAlterarStatus && (
            <>
              Confirmando... &nbsp;
              <CircularProgress size={20} color="inherit" />
            </>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCancelarOperacao;
